<template>
  <v-container class="py-12">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <!-- Card de contacto -->
        <v-card class="pa-6 rounded-xl shadow-lg">
          <v-card-title class="headline font-weight-bold text-center mb-6">
            Contáctanos
          </v-card-title>

          <!-- Formulario -->
          <v-form ref="form" v-model="valid" @submit.prevent="enviarFormulario">
            <v-row>
              <!-- Información de contacto -->
              <v-col cols="12" md="6">
                <div class="mb-4">
                  <v-icon left color="primary">mdi-phone</v-icon>
                  <span class="ml-2">+51 921714371</span>
                </div>

                <div class="mb-4">
                  <v-icon left color="primary">mdi-email</v-icon>
                  <span class="ml-2">informes@consultora-innova.com</span>
                </div>

                <div class="mb-4">
                  <v-icon left color="primary">mdi-map-marker</v-icon>
                  <span class="ml-2">Av. Uruguay 466, Ofic 302, Lima, Perú</span>
                </div>

                <v-divider class="my-4"></v-divider>

                <h3 class="subtitle-1 font-weight-bold mb-2">Horario de atención</h3>
                <p>Lunes a Viernes: 9:00 am - 6:00 pm</p>
                <p>Sábados: 9:00 am - 1:00 pm</p>

                <!-- Mapa -->
                <iframe
                  width="100%"
                  height="250"
                  frameborder="0"
                  style="border: 0"
                  src="https://www.google.com/maps?q=Av.+Uruguay+466,+Lima,+Peru&output=embed"
                  allowfullscreen
                ></iframe>
              </v-col>

              <!-- Campos del formulario -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="nombre"
                  label="Nombre"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'El nombre es obligatorio']"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="correo"
                  label="Correo"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'El correo es obligatorio',
                    (v) => /.+@.+\..+/.test(v) || 'Correo inválido',
                  ]"
                  required
                ></v-text-field>

                <v-select
                  v-model="pais"
                  :items="paises"
                  label="País"
                  outlined
                  dense
                  item-text="display"
                  item-value="code"
                  :rules="[(v) => !!v || 'Seleccione un país']"
                  required
                >
                  <template v-slot:selection="{ item }">
                    <span>{{ item.flag }} {{ item.code }}</span>
                  </template>
                  <template v-slot:item="{ item }">
                    <span>{{ item.flag }} {{ item.name }} ({{ item.code }})</span>
                  </template>
                </v-select>

                <v-text-field
                  v-model="telefono"
                  label="Teléfono de contacto"
                  outlined
                  dense
                  :prefix="pais"
                  :rules="[
                    (v) => !!v || 'El teléfono es obligatorio',
                    (v) => /^\d{7,15}$/.test(v) || 'Número inválido',
                  ]"
                  required
                ></v-text-field>

                <v-select
                  v-model="tipoDocumento"
                  :items="tiposDocumento"
                  label="Tipo de documento"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Seleccione un tipo de documento']"
                  required
                ></v-select>

                <v-text-field
                  v-model="numeroDocumento"
                  :label="`Número de ${tipoDocumento || 'Documento'}`"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"
                  required
                ></v-text-field>

                <v-textarea
                  v-model="mensaje"
                  label="Mensaje"
                  outlined
                  rows="4"
                  :rules="[(v) => !!v || 'El mensaje es obligatorio']"
                  required
                ></v-textarea>

                <v-btn color="primary" block class="mt-2" type="submit">Enviar</v-btn>
              </v-col>
            </v-row>
          </v-form>

          <!-- Popup de confirmación -->
          <v-dialog v-model="dialog" max-width="400">
            <v-card>
              <v-card-title class="headline">¡Formulario enviado!</v-card-title>
              <v-card-text>
                Gracias por contactarnos, estaremos revisando su solicitud y nos
                comunicaremos contigo pronto.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Overlay de carga -->
          <v-overlay :value="loading">
            <v-progress-circular
              indeterminate
              size="64"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ConTacto",
  data() {
    return {
      valid: false,
      nombre: "",
      correo: "",
      telefono: "",
      pais: "+51",
      tipoDocumento: "",
      numeroDocumento: "",
      mensaje: "",
      dialog: false,
      loading: false,
      paises: [
        { name: "Perú", code: "+51", flag: "🇵🇪", display: "🇵🇪 +51" },
        { name: "Estados Unidos", code: "+1", flag: "🇺🇸", display: "🇺🇸 +1" },
        { name: "México", code: "+52", flag: "🇲🇽", display: "🇲🇽 +52" },
        { name: "Colombia", code: "+57", flag: "🇨🇴", display: "🇨🇴 +57" },
        { name: "Argentina", code: "+54", flag: "🇦🇷", display: "🇦🇷 +54" },
        { name: "Chile", code: "+56", flag: "🇨🇱", display: "🇨🇱 +56" },
        { name: "Brasil", code: "+55", flag: "🇧🇷", display: "🇧🇷 +55" },
        { name: "España", code: "+34", flag: "🇪🇸", display: "🇪🇸 +34" },
        { name: "Francia", code: "+33", flag: "🇫🇷", display: "🇫🇷 +33" },
        { name: "Italia", code: "+39", flag: "🇮🇹", display: "🇮🇹 +39" },
      ],
      tiposDocumento: ["DNI", "Carnet de extranjería", "Pasaporte"],
    };
  },
  methods: {
    async enviarFormulario() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const response = await axios.post("http://localhost:3000/enviar-correo", {
            nombre: this.nombre,
            correo: this.correo,
            telefono: this.telefono,
            pais: this.pais,
            tipoDocumento: this.tipoDocumento,
            numeroDocumento: this.numeroDocumento,
            mensaje: this.mensaje,
          });

          if (response.status === 200) {
            this.dialog = true;

            // Limpiar formulario
            this.nombre = "";
            this.correo = "";
            this.telefono = "";
            this.pais = "+51";
            this.tipoDocumento = "";
            this.numeroDocumento = "";
            this.mensaje = "";
            this.$refs.form.resetValidation();
          } else {
            alert("Hubo un error al enviar el correo. Intenta nuevamente.");
          }
        } catch (error) {
          console.error(error);
          alert("Error al conectar con el servidor. Verifica que Node esté corriendo.");
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  background: #ffffff;
}
</style>
